export default "__VITE_ASSET__CA4ut$Xw__"